import React, { useState, useEffect, useRef } from "react";
import * as url from "../../../../utils/url";
import axios from "../../../../axios";
import {
  Button,
  Card,
  Row,
  Col,
} from "reactstrap";
import { FaExclamationTriangle } from "react-icons/fa";
import TextSentimentComponentOverall from "./TextSentimentComponentOverall";
import { BiRecycle } from "react-icons/bi";
import parse from "react-html-parser";
import { BsStar, BsStars, BsDownload } from "react-icons/bs";
import EmptyTable from "../../../../components/EmptyTable/EmptyTable";
import MessagingResponseFullModal from "./MessagingResponseFullModal";
import {
  LayoutHeading,
  LayoutData,
} from "../../../weekly-wins/TableLayoutComponents";
import { LayoutRow } from "../../../../components/TableComponents/RowBordered/RowBordered";
import {
  SENTIMENTS_COLOR_MAP2,
  SENTIMENTS_TYPO_MAP,
  SENTIMENTS_TYPO_MAP2,
  showYou,
} from "../../data";
import { isMobile } from "../../../../utils/deviceInfo";
import { profilePicValidityCheck } from "../../../../utils/constants";
import moment from "moment";
import SeeMoreWrapper from "../../../../components/Shared/SeeMoreWrapper";
import "./resultsComponents.css";
// import { useNavigate } from "react-router-dom";

// const navigate = useNavigate();
import { withRouter } from "react-router-dom";
import SpinnerLoader from "../../../../components/UI/SpinnerLoader/SpinnerLoader";

import { BiUpArrowAlt, BiDownArrowAlt, BiHide } from "react-icons/bi";
import { BsThreeDotsVertical } from "react-icons/bs";
import { orderBy } from "lodash";

import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";

function MessagingTriviaResultsResponses({
  trivia,
  user,
  userSubmissions,
  history: routerHistory,
  setNeedsAttentionSortTrigger,
  needsAttentionSortTrigger,
  isFilterLoading,
  ...props
}) {
  const [originalResponsesData, setOriginalResponsesData] = useState([]);
  const [responsesData, setResponsesData] = useState([]);
  const [fullTextModal, setFullTextModal] = useState(null);
  const [sortParams, setSortParams] = useState({ sortBy: "date", sortOrder: "desc" });
  const [dropdownOpenCol, setDropdownOpenCol] = useState(null);
  const [exportLoading, setExportLoading] = useState(false);
  const hasSortedNeedsAttention = useRef(false);

  // Dropdown logic for column menu
  const toggleCol = (col) => {
    setDropdownOpenCol(dropdownOpenCol === col ? null : col);
  };

  const renderDDtab = (col, label) => {
    const isSortedByThisCol = sortParams.sortBy === col;
    const nextSortOrder = isSortedByThisCol && sortParams.sortOrder === "asc" ? "desc" : "asc";

    return (
      <Dropdown isOpen={dropdownOpenCol === col} toggle={() => toggleCol(col)} direction="down">
        <DropdownToggle
          size="sm"
          tag={"span"}
          className="action-table-col-overlap"
          style={{ cursor: "pointer", padding: 0, marginLeft: 6 }}
        >
          <span className="TriviaEditViewListUI_leftContainer_singleQuestion_threedots_wrapper">
            <BsThreeDotsVertical />
          </span>
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem onClick={() => { setSortParams({ sortBy: col, sortOrder: nextSortOrder }); setDropdownOpenCol(null); }}>
            {nextSortOrder === 'asc' ?
              <BiUpArrowAlt size={"18px"} style={{ verticalAlign: 'middle' }} /> :
              <BiDownArrowAlt size={"18px"} style={{ verticalAlign: 'middle' }} />
            }
            {' '}
            Sort
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    );
  };

  const handleFetchUsers = async () => {
    axios
      .get(url.getMessagingResponses(trivia._id))
      .then(({ data }) => {
        console.log("48 --- ", data);
        // BE quirk (email-sent messaging trivvys): the backend creates
        // TWO records per user — a placeholder with no `messagingResponse`
        // but the correct `createdOn` (= true send time), and a second
        // record with the actual response text whose `createdOn` is the
        // response timestamp (NOT the send time). We hide the placeholder
        // row to avoid the duplicate "No response" UI, but first salvage
        // its `createdOn` and use it as the displayed sent date for the
        // response row, keyed by userId. SMS sends use a single record
        // so this map is empty for them and the existing fallback applies.
        const placeholderSentByUser = {};
        data.data.forEach((res) => {
          const hasResponseText =
            res.messagingResponse && res.messagingResponse.text;
          if (hasResponseText) return;
          const userKey = res.userId && res.userId._id ? res.userId._id : null;
          if (!userKey || !res.createdOn) return;
          if (
            !placeholderSentByUser[userKey] ||
            new Date(res.createdOn) < new Date(placeholderSentByUser[userKey])
          ) {
            placeholderSentByUser[userKey] = res.createdOn;
          }
        });

        const dataFormatted = data.data
          .filter((res) => res.messagingResponse && res.messagingResponse.text)
          .map((res) => {
            const userKey =
              res.userId && res.userId._id ? res.userId._id : null;
            const salvagedSentDate =
              userKey && placeholderSentByUser[userKey]
                ? placeholderSentByUser[userKey]
                : null;
            // NOTE: in the legacy render, `result.date` shows under the
            // "Sent Date" header and `result.sentDate` shows under
            // "Response Date" (field names are intentionally inverted).
            // So the salvaged email-send timestamp goes into `date`.
            const defaultDate = res.dateTrivvySent
              ? res.dateTrivvySent
              : res.messagingResponse
                ? res.messagingResponse.respondedDate
                : res.createdOn;
            return {
              user: res.userId ? res.userId : res.userData,
              response: res.messagingResponse.text,
              date: salvagedSentDate || defaultDate,
              sentimentData:
                res.sentimentsScore && res.sentimentsScore.sentiment
                  ? res.sentimentsScore
                  : null,
              sentDate: res.isSubmittedDate || '',
              needsAttention: res.needsAttention,
              ...res,
            };
          });

        setOriginalResponsesData(dataFormatted);
      })
      .catch((err) => {
        console.log(err);
      });
  };


  useEffect(() => {
    handleFetchUsers();
  }, []);


  useEffect(() => {
    if (
      userSubmissions &&
      userSubmissions.length === 1 &&
      userSubmissions[0] === "filter"
    ) {
      handleFetchUsers();
    } else if (userSubmissions && userSubmissions.users) {
      const dataFormatted = userSubmissions.users
        .filter((res) => res.messagingResponse)
        .map((res) => ({
        user: res.userId,
        response: res.messagingResponse.text || "No response",
        date: res.dateTrivvySent ? res.dateTrivvySent : res.messagingResponse
          ? res.messagingResponse.respondedDate
          : res.createdOn,
        sentDate: res.isSubmittedDate || '',
        sentimentData:
          res.sentimentsScore && res.sentimentsScore.sentiment
            ? res.sentimentsScore
            : null,
        needsAttention: res.needsAttention,
      }));
      setOriginalResponsesData(dataFormatted);
    }
  }, [userSubmissions]);

      // Parse URL query params for initial sorting on mount
    useEffect(() => {
      const searchParams = new URLSearchParams(props.location.search);
      const sortBy = searchParams.get('sortBy');
      const sortOrder = searchParams.get('sortOrder');
      if ((!hasSortedNeedsAttention.current || needsAttentionSortTrigger) && sortBy === 'needsAttention' && sortOrder && responsesData && responsesData.length > 0) {
        let list = [...responsesData];
        list = orderBy(list, (itm) => itm.needsAttention ? 1 : 0, [sortOrder]);
        setResponsesData(list);
        hasSortedNeedsAttention.current = true;
        setNeedsAttentionSortTrigger(false);
      }
    }, [responsesData, props.location.search, needsAttentionSortTrigger]);

  // Sorting logic
  useEffect(() => {
    let list = [...originalResponsesData];
    const { sortBy, sortOrder } = sortParams;

    if (!sortBy || !sortOrder) {
      setResponsesData(list);
      return;
    }

    switch (sortBy) {
      case "date":
        list = orderBy(list, (itm) => itm.date ? moment(itm.date).valueOf() : 0, [sortOrder]);
        break;
      case "sentDate":
        list = orderBy(list, (itm) => itm.sentDate ? moment(itm.sentDate).valueOf() : 0, [sortOrder]);
        break;
      case "user":
        list = orderBy(list, (itm) => {
          if (!itm.user) return "";
          const first = itm.user.firstName || "";
          const last = itm.user.lastName || "";
          return (first + " " + last).toLowerCase();
        }, [sortOrder]);
        break;
      case "sentimentData":
        list = orderBy(list, (itm) => {
          if (!itm.sentimentData || !itm.sentimentData.sentiment) return "";
          return SENTIMENTS_TYPO_MAP2[itm.sentimentData.sentiment] || "";
        }, [sortOrder]);
        break;
      case "response":
        list = orderBy(list, (itm) => (itm.response || "").toLowerCase(), [sortOrder]);
        break;
      case "needsAttention":
        list = orderBy(list, (itm) => itm.needsAttention ? 1 : 0, [sortOrder]);
        break;
      case "conversationMessageCount":
        list = orderBy(list, (itm) => itm.conversationMessageCount == null ? 0 : itm.conversationMessageCount, [sortOrder]);
        break;
      default:
        break;
    }
    setResponsesData(list);
  }, [originalResponsesData, sortParams]);

  const sortComponent = (key) => {
    if (
      sortParams.sortBy === key &&
      sortParams.sortOrder === "asc"
    ) {
      return <BiDownArrowAlt size={"18px"} style={{ verticalAlign: 'middle' }} />;
    } else if (sortParams.sortBy === key && sortParams.sortOrder === "desc") {
      return <BiUpArrowAlt size={"18px"} style={{ verticalAlign: 'middle' }} />;
    } else {
      return null;
    }
  };

  let isDataExists = responsesData && responsesData.length > 0;

  const getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "N";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  const openChatHistoryModal = (result) => {
    const allResult = {
      ...result,
      comingFromNeedsAttention: true,
    };
    setFullTextModal(allResult);
  };

  if (isFilterLoading) {
    return (
      <div style={{ marginTop: "48px", minHeight: "300px", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <SpinnerLoader />
      </div>
    );
  }

  const handleExportCSV = () => {
    setExportLoading(true);
    axios
      .get(url.exportMessagingResponsesCSV(trivia._id))
      .then(function (response) {
        var csvData = response && response.data && response.data.data;
        if (!csvData) {
          setExportLoading(false);
          return;
        }

        var csvRows = [];
        csvRows.push(csvData.headers.join(","));

        if (csvData.rows && csvData.rows.length > 0) {
          for (var i = 0; i < csvData.rows.length; i++) {
            var row = csvData.rows[i].map(function (cell, colIndex) {
              // Columns 1 (Sent Date) and 2 (Response Date) are raw ISO dates — format in browser timezone
              if ((colIndex === 1 || colIndex === 2) && cell) {
                var cellStr = moment(cell).format("lll");
              } else {
                var cellStr = cell === null || cell === undefined ? "" : String(cell);
              }
              if (!cellStr && (colIndex === 1)) cellStr = "N/A";
              if (!cellStr && (colIndex === 2)) cellStr = "-";
              if (cellStr.indexOf(",") !== -1 || cellStr.indexOf('"') !== -1 || cellStr.indexOf("\n") !== -1) {
                cellStr = '"' + cellStr.replace(/"/g, '""') + '"';
              }
              return cellStr;
            });
            csvRows.push(row.join(","));
          }
        }

        var csvString = csvRows.join("\n");
        var blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
        var downloadUrl = URL.createObjectURL(blob);
        var link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute(
          "download",
          (trivia.name || "Messaging Trivia") + " - " + moment().format("MM/DD/YYYY") + ".csv"
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(downloadUrl);
        setExportLoading(false);
      })
      .catch(function (err) {
        console.log("Error exporting CSV:", err);
        setExportLoading(false);
      });
  };

  return (
    <div>
      <Card className="p-3">
        {/* <div>
          {" "}
          <h5>Message Title: </h5>
          <div>
            {" "}
            {trivia.name ? trivia.name : `No title`} */}
        {/* `${trivia.messagingSubject.slice(0, 10)}...` */}
        {/* </div>
        </div> */}
        <h5>
          <strong>{trivia.name ? trivia.name : "No title"}:</strong>{" "}
          {trivia.messagingSubject}
        </h5>
        {/* <div className="mt-4">
          <h5>Message Content:</h5>
          {trivia.messagingSubject}
        </div> */}
      </Card>

      {fullTextModal && (
        <MessagingResponseFullModal
          data={fullTextModal}
          onClose={() => setFullTextModal(null)}
          user={user}
          adminAId={trivia && trivia.createdBy && (trivia.createdBy._id || trivia.createdBy)}
        />
      )}

      <div className="mt-4">
        <div>
          {responsesData.length > 0 ? (
            <>
              <div className="d-flex justify-content-start mb-3">
                <button
                  className="btn messages-export trivia-action-button-main btn-sm"
                  onClick={handleExportCSV}
                  disabled={exportLoading}
                >
                  <span className="export-btn">
                    {exportLoading ? "Exporting..." : "Export CSV"} <BsDownload size={13} />
                  </span>
                </button>
              </div>
              {/* Single unified scroll container so every cell in a row
                  shares the same natural row height (tallest cell sets
                  it). This avoids the row drift you get when User and
                  data columns each render in their own scroll wrapper
                  and their row heights diverge. Sticky header + internal
                  vertical scroll still work as intended. */}
              <div className={`actions-table-div results-invidual-table p0 trivvyUserResTable`}>
                <div
                  className="trivvyUserResTable-data-scroll-right"
                  style={{
                    overflowX: "hidden",
                    maxHeight: "calc(75vh - 220px)",
                  }}
                >
                  <div className="trivvyUserResTable-sticky-header">
                    <LayoutRow
                      className="mobileNoheightActionTable"
                      style={{
                        backgroundColor:
                          responsesData && responsesData.length > 0
                            ? ""
                            : "#8080802b",
                      }}
                    >
                      <LayoutHeading
                        className="p-3 border-gray-thin"
                        colWidth={2}
                        plainTable
                      >
                        <span style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                          User {renderDDtab("user", "User")}
                        </span>
                      </LayoutHeading>
                      <LayoutHeading
                        className="p-3 border-gray-thin"
                        colWidth={2}
                        plainTable
                      >
                        <span style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                          Sent Date {renderDDtab("sentDate", "Sent Date")}
                        </span>
                      </LayoutHeading>
                      <LayoutHeading
                        className="p-3 border-gray-thin"
                        colWidth={2}
                        plainTable
                      >
                        <span style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                          Response Date {renderDDtab("date", "Response Date")}
                        </span>
                      </LayoutHeading>
                      <LayoutHeading
                        className="p-3 border-gray-thin"
                        colWidth={3}
                        plainTable
                      >
                        <span style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                          Response {renderDDtab("response", "Response")}
                        </span>
                      </LayoutHeading>
                      <LayoutHeading
                        className="p-3 border-gray-thin"
                        colWidth={1}
                        plainTable
                      >
                        <span style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                          Sentiment {renderDDtab("sentimentData", "Sentiment")}
                        </span>
                      </LayoutHeading>
                      <LayoutHeading
                        className="p-3 border-gray-thin"
                        colWidth={1}
                        plainTable
                      >
                        <span style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                          Needs Attention {renderDDtab("needsAttention", "Needs Attention")}
                        </span>
                      </LayoutHeading>
                      <LayoutHeading
                        className="p-3 border-gray-thin"
                        colWidth={1}
                        plainTable
                      >
                        <span style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                          Message History {renderDDtab("conversationMessageCount", "Message History")}
                        </span>
                      </LayoutHeading>
                    </LayoutRow>
                  </div>
                  {responsesData.map((result, i) => (
                    <LayoutRow
                      key={`row-${i}`}
                      className={`pl-tasks-row cursor-pointer`}
                      style={{ margin: 0 }}
                      onClick={() => openChatHistoryModal(result)}
                    >
                      <LayoutData
                        colWidth={2}
                        className={"border-gray-thin"}
                      >
                        {result.user && !result.isAnonymous ? (
                          <span
                            className="trivia_table_text_wrapper"
                            onClick={(e) => {
                              e.stopPropagation();
                              if (
                                result &&
                                result.user &&
                                result.user._id &&
                                routerHistory &&
                                routerHistory.push
                              ) {
                                routerHistory.push(
                                  `/home/${result.organizationId}/profile/${result.user._id}`
                                );
                              }
                            }}
                          >
                            {profilePicValidityCheck(
                              result.user.profilePic
                            ) ? (
                              <img
                                src={result.user.profilePic}
                                height="35px"
                                width="35px"
                                style={{ borderRadius: "50%" }}
                              />
                            ) : (
                              <span
                                className="spotlightUserInitials"
                                data-letters={getInitials(result.user)}
                              ></span>
                            )}{" "}
                            {result.user.firstName || result.user.lastName ? (
                              <>
                                {result.user.firstName} {result.user.lastName}
                              </>
                            ) : result.user.email ? (
                              result.user.email
                            ) : result.user.mobileNumber ? (
                              result.user.mobileNumber
                            ) : result.user.firstName ||
                              result.user.lastName ? (
                              result.user.firstName || result.user.firstName
                            ) : result.user.employeeId ? (
                              result.user.employeeId
                            ) : result.user.identification ? (
                              result.user.identification
                            ) : (
                              ""
                            )}
                          </span>
                        ) : (
                          <span className="trivia_table_text_wrapper">
                            <span
                              className="spotlightUserInitials"
                              data-letters={"AU"}
                            ></span>
                            Anonymous user{" "}
                            {showYou(user.profile, result) ? "(You)" : ""}
                          </span>
                        )}
                      </LayoutData>
                      <LayoutData colWidth={2}>
                        <span className={"trivia_table_text_wrapper"}>
                          {moment(result.date).format("lll")}{" "}
                        </span>
                      </LayoutData>
                      <LayoutData colWidth={2}>
                        <span className={"trivia_table_text_wrapper"}>
                          {result.sentDate ? moment(result.sentDate).format("lll") : "-"}
                        </span>
                      </LayoutData>

                      <LayoutData
                        colWidth={3}
                        customStyle={{
                          ...(result.sentimentData && {
                            backgroundColor:
                              SENTIMENTS_COLOR_MAP2[
                                result.sentimentData.sentiment
                              ],
                          }),
                        }}
                      >
                        <div style={{fontSize: '12px'}}>
                          <SeeMoreWrapper
                            text={result.response}
                            limit={80}
                            openModal={() => {
                              setFullTextModal(result);
                            }}
                          />
                        </div>
                      </LayoutData>

                      <LayoutData
                        colWidth={1}
                        customStyle={{
                          ...(result.sentimentData && {
                            backgroundColor:
                              SENTIMENTS_COLOR_MAP2[
                                result.sentimentData.sentiment
                              ],
                          }),
                        }}
                      >
                        <span className={"trivia_table_text_wrapper"}>
                          {result.sentimentData ? (
                            <div>
                              {
                                SENTIMENTS_TYPO_MAP2[
                                  result.sentimentData.sentiment
                                ]
                              }
                            </div>
                          ) : (
                            "N/A"
                          )}
                        </span>
                      </LayoutData>

                      <LayoutData
                        colWidth={1}
                        customStyle={{ alignItems: "center" }}
                      >
                        <div>
                          {result.needsAttention ? (
                            <FaExclamationTriangle
                              color="goldenrod"
                              size="1.8em"
                            />
                          ) : (
                            "-"
                          )}
                        </div>
                      </LayoutData>

                      <LayoutData
                        colWidth={1}
                        customStyle={{ alignItems: "center" }}
                      >
                        <span style={{fontSize: '12px'}}>{result.conversationMessageCount == 0 ? 1 : result.conversationMessageCount}</span>
                      </LayoutData>
                    </LayoutRow>
                  ))}
                </div>
              </div>
            </>
          ) : (
            <div className="d-flex justify-content-center">
              <EmptyTable
                title={"No responses found"}
                subtitle={"No user has submitted any responses yet."}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default withRouter(MessagingTriviaResultsResponses);
